// LUMINA · pages/vajra/PracticeHub.jsx
// Phase 39A: 修行 Tab — 修行日志 + 传承法教 双子视图

import React from 'react';
import { GD, GDH, TXT2 } from './constants';
import MyMandala from './components/MyMandala';
import DharmaLineagePage from './components/DharmaLineagePage';
import MyCredentials from './components/MyCredentials';

export default function PracticeHub({ token, member, lang, T }) {
  const t = T || {};
  const [view, setView] = React.useState("mandala");

  if (!member) return (
    <div style={{textAlign:"center",padding:"80px 24px"}}>
      <div style={{fontSize:40,marginBottom:16}}>🧘</div>
      <div style={{fontSize:16,color:GD,letterSpacing:2,marginBottom:8}}>
        {lang === "zh" ? "登录后查看修行记录" : "Login to view your practice"}
      </div>
      <div style={{fontSize:13,color:TXT2}}>
        {lang === "zh" ? "记录每日修行，设定目标，追踪进步" : "Log daily practice, set goals, track progress"}
      </div>
    </div>
  );
  const btnStyle = (k) => ({
    padding: "6px 20px", borderRadius: 20, fontSize: 12, cursor: "pointer",
    background: view === k ? GDH : "transparent",
    border: `1px solid ${view === k ? GDH : "rgba(212,175,55,0.3)"}`,
    color: view === k ? "#fff" : GD,
    marginRight: 8,
  });
  return (
    <div>
      <div style={{ padding: "20px 0 8px" }}>
        <button style={btnStyle("mandala")} onClick={() => setView("mandala")}>{t.practiceMyJourney || "修行日志"}</button>
        <button style={btnStyle("lineage")} onClick={() => setView("lineage")}>{t.practicePath || "传承法教"}</button>
        <button style={btnStyle("creds")}   onClick={() => setView("creds")}>{t.settingsMyCredentials || "我的资质"}</button>
      </div>
      {view === "mandala" && <MyMandala token={token} member={member}/>}
      {view === "lineage" && <DharmaLineagePage member={member} setTab={() => setView("mandala")}/>}
      {view === "creds"   && <MyCredentials token={token}/>}
    </div>
  );
}
